import React from 'react';
import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcInputTitle from 'components/molecules/PcInputTitle';
import PcStepProgressBar from 'components/molecules/PcStepProgressBar';
import PcPointComment from 'components/molecules/PcPointComment';
import PcErrorArea from 'components/molecules/PcErrorArea';

import {
  POINT_COMMENT_MAP
} from 'utils/constant';

const PresentPC = ({
  onClickMainButton,
  ExcelskillDisp,
  OtherSkillsDisp,
  skillOtherCmntDisp,
  valid,
}) => (
  <div className="">
    <div className="AddSkill PC">
      <PcBasicTemplate
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
      >
        {/* プログレスバー */}
        <div className="pc-StepProgressBar">
          <PcStepProgressBar currentStep="4" />
        </div>
        <div className="titleArea">
          <div className="title">業務に用いるスキル</div>
        </div>
        <PcPointComment labelList={POINT_COMMENT_MAP.skillPointCmnt.labelList} pattern={POINT_COMMENT_MAP.skillPointCmnt.pattern} />
        {/* Excelスキル */}
        <PcInputTitle
          title={ExcelskillDisp.title}
          subTitle={ExcelskillDisp.subTitle}
          label={ExcelskillDisp.label}
          list={ExcelskillDisp.list}
          type={ExcelskillDisp.type}
        />

        <div className="mT10" />

        {/* その他スキル */}
        <PcInputTitle
          title={OtherSkillsDisp.title}
          subTitle={OtherSkillsDisp.subTitle}
          label={OtherSkillsDisp.label}
          list={OtherSkillsDisp.list}
          type={OtherSkillsDisp.type}
        />

        {/* その他、ご希望のスキルや経験のテキストエリア */}
        <div className="skillOtherCmntDisp">
          <PcInputTitle
            title={skillOtherCmntDisp.title}
            label={skillOtherCmntDisp.label}
            list={skillOtherCmntDisp.list}
            value={skillOtherCmntDisp.value}
            type={skillOtherCmntDisp.type}
          />
          <span className="">
            <PcErrorArea
              position="relative"
              message={skillOtherCmntDisp.errorDispMessages}
            />
          </span>
        </div>
      </PcBasicTemplate>
    </div>
  </div>
);

export default PresentPC;
